module.exports = __webpack_public_path__ + "img/pic_xiyiye2.26a2cb90.png";